import { cloneDeep } from "lodash";
import * as PostEditorTabsTypes from "./PostEditorTabsTypes.constants";
import { getSeparatedData, getStateForTab } from "./helpers";

export const tabsStateInit = (initialData = {}) => {
  const data = {};

  Object.keys(initialData).forEach((tab) => {
    if (tab !== PostEditorTabsTypes.BASE) {
      data[tab] = getStateForTab(getSeparatedData(initialData[tab]), tab);
    }
  });

  data[PostEditorTabsTypes.BASE] = getStateForTab(
    getSeparatedData(initialData[PostEditorTabsTypes.BASE]),
    PostEditorTabsTypes.BASE
  );

  return data;
};

export const tabsStateReducer = (state, action) => {
  switch (action.type) {
    case "merge": {
      const tabState =
        state[action.tab] ||
        getStateForTab(state[PostEditorTabsTypes.BASE], action.tab);

      return {
        ...state,
        [action.tab]: getStateForTab(
          {
            ...tabState,
            ...cloneDeep(action.payload),
          },
          action.tab
        ),
      };
    }
    case "set": {
      return {
        ...state,
        [action.tab]: cloneDeep(action.payload || {}),
      };
    }
    case "reset": {
      const { [action.tab]: tabState, ...newState } = state;
      return cloneDeep(newState || {});
    }
    case "init": {
      return tabsStateInit(action.payload);
    }
    default: {
      return state;
    }
  }
};
